import classNames from 'classnames';
import { ELSIcon, ELSIconV2 } from 'components/common';
import { getAssignmentTypeById } from 'reports/cw/constants/report.constant';
var sizeMap = {
    '3o4': 'xxs',
    '1x': 'xs',
    '1x1o2': 's',
    '2x': 'm',
    '3x': 'ml',
    '4x': 'l',
    '5x': 'xl'
};
var getIconSize = function (size) {
    return {
        className: "o-els-icon-svg--".concat(size),
        size: sizeMap[size] || 'xs'
    };
};
var wrapperSizeMap = {
    '3o4': 'c-cw-assignment-type-icon-background--1x1o4',
    '1x': 'c-cw-assignment-type-icon-background--1x1o2',
    '1x1o2': 'c-cw-assignment-type-icon-background--2x',
    '2x': 'c-cw-assignment-type-icon-background--2x1o2'
};
var getWrapperSizeClass = function (size) {
    return wrapperSizeMap[size] || 'c-cw-assignment-type-icon-background--1x1o2';
};
var newBrandIconSizeMap = {
    '3o4': '1x',
    '1x': '1x1o2',
    '1x1o2': '2x',
    '2x': '3x'
};
export var AssignmentTypeIcon = function (_a) {
    var _b;
    var type = _a.type, size = _a.size, name = _a.name, iconClassName = _a.iconClassName;
    var _c = (getAssignmentTypeById(type) || {}), icon = _c.icon, isCustomIcon = _c.isCustomIcon;
    var iconName = name || icon;
    if (!iconName) {
        return null;
    }
    if (isCustomIcon) {
        return <ELSIcon size={size || '1x'} name={iconName}/>;
    }
    var _d = getIconSize(size), iconSize = _d.size, elsClassName = _d.className;
    return <ELSIconV2 size={iconSize} sprite={iconName} className={classNames((_b = {}, _b[elsClassName] = !iconSize, _b), iconClassName)}/>;
};
var AssignmentTypeIconWrapper = function (_a) {
    var className = _a.className, titleClassName = _a.titleClassName, size = _a.size, iconClassName = _a.iconClassName, type = _a.type, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.showTitle, showTitle = _c === void 0 ? true : _c;
    var _d = (getAssignmentTypeById(type) || {}), title = _d.name, color = _d.color, isNewBrandIconStyle = _d.isNewBrandIconStyle;
    var iconSize = isNewBrandIconStyle ? newBrandIconSizeMap[size || '1x'] || size : size;
    var wrapperSizeClass = getWrapperSizeClass(size);
    return (<div className={classNames('c-cw-assignment-type-icon-wrapper', className)}>
      <div className={classNames('c-cw-assignment-type-icon', color, wrapperSizeClass)}>
        <AssignmentTypeIcon type={type} size={iconSize} name={name} iconClassName={iconClassName}/>
      </div>
      {showTitle && <span className={titleClassName}>{title}</span>}
    </div>);
};
export default AssignmentTypeIconWrapper;
